"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var flattenSections = function flattenSections(sections) {
  return sections.reduce(function (acc, section) {
    return section.sections ? acc.concat([section]).concat(flattenSections(section.sections)) : acc.concat([section]);
  }, []);
};

var _default = flattenSections;
exports["default"] = _default;